import { BulletinStatusType, PoiId, IBulletin, ICommercialBulletin, User } from 'utils/entities';
import { EditListingStatusParams } from 'store/state/uploadBulletin/actions';
import { UserPromotionPlan, UserBulletinPromotionPlan } from 'store/sagas/apiService/types';
import { CancelSubscriptionThenEditListingStatusPayload, CancelUserPromotionPlanPayload } from 'store/state/app/private-user-monetization/actions';

export enum UpdateListingStatusModalSource {
  ListingPage = 'property_page',
  ManageListingsPage = 'manage_bulletins_page',
}

export interface IUpdateListingStatusModal {
  status: BulletinStatusType;
  id: PoiId;
  source: UpdateListingStatusModalSource;
}

export interface UpdateListingStatusPopupProps {
  poi: IBulletin | ICommercialBulletin;
  editListingStatus?: (data: EditListingStatusParams) => void;
  setModalOpenStatus?: (v: IUpdateListingStatusModal | null) => void;
  status?: BulletinStatusType;
  onPopupOpen?: () => void;
  source: UpdateListingStatusModalSource;
  currentUser: User;
  onCancelPromotionPlan?: (payload: CancelUserPromotionPlanPayload) => void;
  promotionPlan?: UserPromotionPlan | UserBulletinPromotionPlan | null;
  cancelSubscriptionThenEditListingStatus?: (payload: CancelSubscriptionThenEditListingStatusPayload) => void;
}
